<template>
    <CDropdown ref="dropdown" :disabled="preview" mobile-bottom-sheet padding-none placement="right">
        <template #trigger="{ isOpen }">
            <CButton
                :active="isOpen"
                class="w-full disabled:!bg-transparent !text-gray-600 dark:!text-gray-400 hover:!text-gray-900 dark:hover:!text-gray-200 !no-underline hover:!no-underline"
                :disabled="preview"
                icon="share"
                size="small"
                variant="text"
                @click="trackShare(isOpen)"
            >
                <span class="!no-underline" :class="{ 'hidden sm:block': hideTextOnMobile }">{{ $t('shareItem.shareButton', lang) }}</span>
            </CButton>
        </template>

        <template #content="{ close }">
            <div class="sticky top-0 z-1 rounded-t-md bg-white dark:bg-surface-card px-2 py-3 sm:w-[340px]">
                <CClose @click="close()" />

                <p class="mb-4 text-left">
                    <strong>{{ $t('shareItem.dropdownTitle', lang) }}</strong>
                </p>

                <div class="flex-row space-y-2 text-left sm:flex sm:space-x-3 sm:space-y-0">
                    <CShareEmail :subject="`GROWNi.sk: ${title}`" :url="sharedUrl" @click="trackShareItem('email')" />
                    <CShareFacebook :url="sharedUrl" @click="trackShareItem('facebook')" />
                    <CShareLinkedIn :url="sharedUrl" @click="trackShareItem('linkedin')" />
                    <CShareTelegram :title="title" :url="sharedUrl" @click="trackShareItem('telegram')" />
                    <CShareTwitter :title="title" :url="sharedUrl" @click="trackShareItem('twitter')" />
                    <CShareWhatsapp :title="title" :url="sharedUrl" @click="trackShareItem('whatsapp')" />
                </div>

                <CCopyLink :shared-url="sharedUrl" />
            </div>
        </template>
    </CDropdown>
</template>

<script setup lang="ts">
import { useApplicationStore } from '@/stores/application'
import { ref, onMounted } from 'vue'
import { useExponea } from '@/composables/exponea/useExponea'

const props = defineProps({
    type: {
        type: String,
        required: true
    },
    title: {
        type: String,
        required: true
    },
    id: {
        type: String,
        default: undefined
    },
    lang: {
        type: String,
        default: 'sk'
    },
    preview: {
        type: Boolean,
        default: false
    },
    url: {
        type: String,
        default: null
    },
    hideTextOnMobile: {
        type: Boolean,
        default: false
    }
})

const store = useApplicationStore()
const { trackExponeaEvent } = useExponea()
const sharedUrl = ref('https://growni.sk')

onMounted(() => {
    if (process.client) {
        sharedUrl.value = props.url || window.location.href
    }
})

const trackShare = (isOpen: boolean) => {
    if (props.preview) {
        return
    }
    if (!isOpen) {
        trackExponeaEvent({
            eventName: 'cta1_share',
            userId: store.userId,
            eventProperties: {
                opp_type: props.type,
                opp_name: props.title,
                opp_id: props.id
            }
        })
    }
}

const trackShareItem = (networkType: string) => {
    if (props.preview) {
        return
    }
    trackExponeaEvent({
        eventName: 'cta1_share_network',
        userId: store.userId,
        eventProperties: {
            network_type: networkType,
            opp_type: props.type,
            opp_name: props.title,
            opp_id: props.id
        }
    })
}
</script>
